<template>
  <div id="login-container">
    <br />
    <form id="login__form" @submit.prevent="pressed">
      <div class="login">
        <input type="text" placeholder="login" v-model="email" />
      </div>
      <div class="password">
        <input type="password" placeholder="password" v-model="password" />
      </div>
      <div class="buttons">
        <button class="login-button" @click="cancel">Cancel</button>
        <button class="login-button">Login</button>
      </div>
    </form>
    <div class="error" v-if="error">{{error.message}}</div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
export default {
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    cancel() {
      this.$router.replace({ name: "home" });
    },
    pressed() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(data => {
          this.$router.replace({ name: "schedule" });
        })
        .catch(error => {
          this.error = error;
        });
    }
  }
};
</script>

<style scoped>
#login-container {
  display: grid;
  justify-self: center;
}

#login__form {
  display: grid;
  grid-template-areas: 1fr 1fr;
  justify-items: center;
  align-items: center;
  gap: 5px;
}

input {
  width: 400px;
  padding: 30px;
  font-size: 21px;
}

.buttons {
  margin: 10px;
}

.login-button {
  width: 200px;
  height: 50px;
  font-size: 100%;
}

.error {
  color: red;
}
</style>